import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-course-header',
  standalone: true,
  imports: [NgClass],
  templateUrl: './course-header.html',
})
export class CourseHeader {
  readonly applicationTitle = input('Curso');
  readonly sidebarCollapsed = input(false);
  readonly toggleSidebar = output<void>();

  protected handleToggleSidebar(): void {
    this.toggleSidebar.emit();
  }
}
